function isFunction(value: any): boolean {
  return typeof value === 'function'
}

export default isFunction
